export default "__VITE_ASSET__b431560c__"